import { useCursor } from './CursorContext';

type LinkProps = {
  url: string;
  text: string;
  isCTA: boolean;
}

export default function Link({ url, text, isCTA }: LinkProps) {
  const { enablePointerCursor, disablePointerCursor, enableGo, disableGo, enableEmail, disableEmail } = useCursor();

  return !isCTA ? (
    <a
      href={url}
      onMouseEnter={() => {enablePointerCursor(); enableGo();}}
      onMouseLeave={() => {disablePointerCursor(); disableGo();}}
      target="_blank"
      rel="noreferrer"
      className='inline-block relative'
    >
      <span className='plus absolute'>+</span>
      <span className='border-bottom absolute w-full'></span>
      <span className='link-text inline-block'>{text}</span>
    </a>
  ) : <a href='mailto:jessemartinezdesign@gmail.com' 
        className='email inline-block relative overflow-hidden' 
        onMouseEnter={() => {enablePointerCursor(); enableEmail();}} 
        onMouseLeave={()=> {disablePointerCursor(); disableEmail();}}>
          <span className='plus absolute'>+</span>
          <span className='link-text inline-block'>
            jessemartinez<br></br><span className='second-line relative'>design@gmail.com</span>
          </span>
      </a>;
}